import axios from 'axios';

const ordersStore = {
  state: {
    orders: [],
    selectedOrder: null,
  },
  mutations: {
    toggleOrders(state, id) {
      state.selectedOrder = id;
    },
    openOrders(state, orders) {
      state.orders = orders;
    },
  },
  actions: {
    async allOrders(context, queryParams) {
      return axios
        .get(`${window.BASE_API.PAYMENT}/api/orders?${
          queryParams.accountId ? `accountId=${queryParams.accountId}` : ''
        }${queryParams.status ? `&status=${queryParams.status}` : ''
        }${queryParams.type ? `&type=${queryParams.type}` : ''
        }${queryParams.query ? `&query=${queryParams.query}` : ''}`)
        .then((response) => {
          context.commit('openOrders', response.data.data);

          return response.data.data;
        }).catch(error => Promise.reject(error));
    },

    async getOrderById(context, orderId) {
      return axios
        .get(`${window.BASE_API.PAYMENT}/api/orders/${orderId}?include=transactions`)
        .then(response => response.data.data).catch(error => Promise.reject(error));
    },

    async searchOrders(context, data) {
      return axios
        .get(`${window.BASE_API.PAYMENT}/api/orders?query=${data.query}`)
        .then(response => response.data.data).catch(error => Promise.reject(error));
    },
  },
};

export default ordersStore;



// WEBPACK FOOTER //
// ./src/store/orders/ordersStore.js